<div class="col-12" *ngIf="gridload">
  <app-busy [message]="message"></app-busy>
</div>
<button style="display: none;" (click)="navigateToApplyPermit()" id="actionApplyPermit"></button>
<button style="display: none;" (click)="navigateTo('view',selectedPermit)" id="actionViewApplication"></button>
<button style="display: none;" (click)="navigateTo('edit',selectedPermit)" id="actionEditApplication"></button>
<button style="display: none;" (click)="navigateTo('delete',selectedPermit)" id="actionDeleteApplication"></button>
<button style="display: none;" (click)="navigateTo('cancelApp',selectedPermit)" id="actionCancelApplication"></button>
<img src="../../../../../assets/newimg/arrow-1-3@2x.png"  (click)="onBack()" style="cursor: pointer;margin: 10px;"/>
<strong><h5>Permit Applications for {{dataCntrl.carrier.name}}</h5></strong>

<!-- Nav tabs -->
<ul class="nav nav-tabs" role="tablist">
  <li class="nav-item"><a class="nav-link active" href="#tab1" role="tab" data-toggle="tab">All</a></li>
  <li class="nav-item"><a class="nav-link" href="#tab2" role="tab" data-toggle="tab">Due in one month</a></li>
  <li class="nav-item"><a class="nav-link" href="#tab3" role="tab" data-toggle="tab">Overdue</a></li>
  <li class="nav-item"><a class="nav-link" href="#tab4" role="tab" data-toggle="tab">Track Application</a></li>

</ul>

<!-- Tab panes -->
<div class="tab-content">
  <div role="tabpanel" class="tab-pane fade show active" id="tab1">
    <div class="container-fluid">
      <!-- <ngx-loading [show]="pageload"></ngx-loading> -->
     
      <app-actions [selectedPermit]="selectedPermit"></app-actions>
      <div >
            <br>
              <div class="row">
                <div class="col-md-12">
                  <!-- <ngx-loading [show]="gridload"></ngx-loading> -->
                  <table class="table" cellspacing="0" width="100%">
                    <thead>
                      <tr>
                        <th></th>
                        <th>#</th>
                        <th>Application Number</th>
                        <!--<th>Application Ref</th>-->
                        <th>Permit Type</th>
                       <!--<th>Date Created</th>-->
                        <th>Date Submitted<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(3)"></i></th>
                        <th class="numPermit">No of Permits</th>
                        <th class="numPermit">Total Fees</th>
                        <th>Status</th>
                        <!-- <th class="btn-show hgt-btn"> 
                            <a [routerLink]="['/carrier/permit/application/new/'+dataCntrl.carrierID]" title=""  class=" btn btn-sm mr-2" style="width:180px;float: right;">
                              <img src="../../../../../assets/newimg/add-circle-4@2x.png" height="15"/> Apply for Permit
                            </a>
                          </th> -->
                          <th style="margin-left:5px;">Actions </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="let item of dataCntrl.applications | paginate: { itemsPerPage: pageSize, currentPage: pageNumber, id: 'apps', totalItems: Count }, let i=index">
                                     
                        <td><input type="checkbox" [ngModel]="selectedIndex === item.id" value="{{item.id}}" (change)="CheckedPermit($event,item,item.id)"></td>
                        <td>{{ pageSize * (pageNumber - 1) + (i+1) }}</td> 
                        <td> <a [routerLink]=""   (click)="navigateTo('view',item)"  style="color:#00008b; text-decoration: underline;"><span title ="View application">{{item.id}} </span></a></td>
                        <!-- <td>{{item.reference_num}}</td> -->
                        <td>{{item.permit_type}}</td>
                        <!--<td>{{item.date_created | date:'y/MM/dd'}}</td>-->
                        <td>    <div *ngIf="item.status_id && item.status_id > 1">
                            {{item.submission_date | date:'dd/MM/yyyy'}}
                        </div></td>
                        <td class="numPermit">{{item.number_of_permits}}</td>
                        <td class="balance2">{{item.total_fees}}</td>
                        <td>{{item.status_desc}}</td>
                        <!-- <td style="width: 100px;">
                              <select class="form-control form-control-sm" id="selectControl" (change)="navigateTo($event.target.value,item)">
                                <option value="" disabled selected>Select</option>
                                <option value="view" class="app-option">View Application</option>
                                <option value="edit" *ngIf="item.permit_type_id != 16 && item.permit_type_id != 32  && item.permit_type_id != 17  && item.permit_type_id != 15  &&(item.status_id < permitStatus2 || item.status_id == permitStatus13 || item.status_id == permitStatus2)" class="app-option" >Edit Application</option>
                                <option value="delete" *ngIf="item.status_id == 1 || item.status_id == 11" class="app-option" >Delete Application</option>
                                <option value="cancelApp" *ngIf="item.status_id != 51||item.status_id != 41 ||item.status_id != 92 " class="app-option" >Cancel Application</option>
                              </select>
                        </td> -->
                        <td style="text-align: left; width: 200px !important;">
                          <span *ngIf="!(determineType(item.permit_type_id)?.temp_long_ind == 2 && item.status_id == 11) && item.status != 'AddInfo_1'" id="p" title="Edit Application" style="margin: 0%" class="btn btn-sm pull-center myButton"
                            (click)="navigateTo('edit', item)">
                            <img src="/assets/newimg/border-color-13@2x.png" class="permit-view" />
                          </span>
                          <span *ngIf="(determineType(item.permit_type_id).temp_long_ind == 2 && item.status_id == 11) " id="p" title="View Application" style="margin: 0%" class="btn btn-sm pull-center myButton"
                          (click)="navigateTo('view', item)">
                          <img src="/assets/newimg/visibility-2@2x.png" class="permit-view" />
                        </span>
                        <span *ngIf="item.status == 'AddInfo_1'" id="p" title="Workflow" style="margin: 0%" class="btn btn-sm pull-center myButton"
                        (click)="navigateTo('workflow', item)">
                        <img src="/assets/newimg/visibility-2@2x.png" class="permit-view" />
                      </span>
                          <span id="p" title="Delete Application" style="margin: 0%" class="btn btn-sm pull-center myButton"
                            (click)="navigateTo('delete', item)">
                            <img src="/assets/newimg/delete@1x.png" class="permit-view" />
                          </span>
                        </td>
                        
                      </tr>
                    </tbody>
                  </table>
                  <div style="text-align:center" *ngIf="Count > 10">
                    <!-- <button title="Back" type="button" id="btnBack" (click)="onBack()" class="btn btn-md btn-primary" style="margin-left:10px; "> Back</button> -->
                    <pagination-template #p="paginationApi"></pagination-template>
    
                    <table border="0" cellpadding="0" cellspacing="0" style="float: left;">
                      <tr>
                        <td style="white-space:nowrap;font-weight:bold;padding-right:3px">
                          Show :
                        </td>
                        <td style="white-space: nowrap">
                          <select style="cursor:pointer" [(ngModel)]="pageSize" (ngModelChange)="pageSizeChange()">
                            <option *ngFor="let size of pageSizes()" [ngValue]="size"> {{pageSizeName(size)}} </option>
                          </select>
                        </td>
                      </tr>
                    </table>
                    <pagination-controls previousLabel="Prev"
                    nextLabel="Next"
                    responsive="true" style="float: right;" class="my-pagination" (pageChange)="pageNumber = onPage($event)" id="apps"></pagination-controls>
                  </div>
                  <div style="text-align:center" *ngIf="dataCntrl.applications.length <= 0 && loadCompleted">
                    <h5>No Applications Found</h5>
                  </div>
                </div>
              </div>
            </div>
     
    </div>
  </div>
  <div role="tabpanel" class="tab-pane fade show" id="tab2">Coming Soon</div>
  <div role="tabpanel" class="tab-pane fade show" id="tab3">Coming Soon</div>
  <div role="tabpanel" class="tab-pane fade show" id="tab4">
    <div class="container-fluid">
      <br>
      <div class="row">
        <div class="col-md-12">
          <table class="table" cellspacing="0" width="100%">
            <thead>
              <tr>
                <th>#</th>
                <th>Application Number</th>
                <th>Permit Type</th>
                <th>Date Submitted<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(3)"></i></th>
                <th class="numPermit">No of Permits</th>
                <th class="numPermit">Total Fees</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let item of dataCntrl.applications | paginate: { itemsPerPage: pageSize, currentPage: pageNumber, id: 'apps', totalItems: Count }, let i=index">
                <td>{{ pageSize * (pageNumber - 1) + (i+1) }}</td> 
                <td> <a [routerLink]="" (click)="onWorkflowTracking(item)"  style="color:#00008b; text-decoration: underline;"><span title ="View application">{{item.id}} </span></a></td>
                <td>{{item.permit_type}}</td>
                <td>
                    <div *ngIf="item.status_id && item.status_id > 1">
                        {{item.submission_date | date:'dd/MM/yyyy'}}
                    </div>

                </td>
                <td class="numPermit">{{item.number_of_permits}}</td>
                <td class="balance2">{{item.total_fees}}</td>
                <td>{{item.status_desc}}</td>
              </tr>
            </tbody>
          </table>
          <div style="text-align:center" *ngIf="Count > 10">
            <pagination-template #p="paginationApi"></pagination-template>
            <table border="0" cellpadding="0" cellspacing="0" style="float: left;">
              <tr>
                <td style="white-space:nowrap;font-weight:bold;padding-right:3px">
                  Show :
                </td>
                <td style="white-space: nowrap">
                  <select style="cursor:pointer" [(ngModel)]="pageSize" (ngModelChange)="pageSizeChange()">
                    <option *ngFor="let size of pageSizes()" [ngValue]="size"> {{pageSizeName(size)}} </option>
                  </select>
                </td>
              </tr>
            </table>
            <pagination-controls previousLabel="Prev"
            nextLabel="Next"
            responsive="true" style="float: right;" class="my-pagination" (pageChange)="pageNumber = onPage($event)" id="apps"></pagination-controls>
          </div>
          <div style="text-align:center" *ngIf="dataCntrl.applications.length <= 0">
            <h5>No applications found</h5>
          </div>
        </div>
      </div>
    </div>
     <!-- BEGIN TRACKING POPUP-->
     <button data-toggle="modal" data-target="#addEdit" id="secretButton" style="display:none"></button>
     <div class="modal fade form-group" id="addEdit" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5);">
         <div class="modal-dialog modal-xl" role="document">
             <div class="modal-content">
                 <div class="modal-header">
                     <label class="text-center title">Workflow Details</label>
                     <button type="button" class="close" data-dismiss="modal" id="closeButton" #closebutton aria-label="Close">
               <span aria-hidden="true">&times;</span>
             </button>
                 </div>
                 <div class="modal-body modal-xl">
                  <div class="row">
                    <div class="col-md-12">
                      <!-- <h6>Application ID: {{}} | Applicant Name: {{}} | Application Type: {{}}</h6>                          -->
                    </div>
                  </div>
                   <div class="stepper_wrapper">
                       <div class="stepper_box">
                         <div class="sticky">
                           <div class="step_row" *ngFor="let activity of activities; let i = index; let last = last;">
                             <div class="step step-two" id="other">
                               {{activity.actiontaken}}
                             </div>
                             <div [class]="last ? 'circle last' : 'circle'"  [style.background-color]="activity.currentassignedyn ? background2 : background1">
                               <img *ngIf="!activity.currentassignedyn"
                                 src="../../assets/stepper-img/done-56@2x.png"			  
                                 height="10"
                               />
                               <span style="color: transparent" *ngIf="!activity.currentassignedyn">2</span>
                             </div>
                             <div></div>
                           </div>
                         </div>
                       </div>
                     
                       <div class="stepper-content">
                         <div style="margin-top:25px;">
                         </div>  
                         <div style="margin-top:25px;" *ngFor="let activity of activities">
                           <div class="row">
                               <div class="col-sm-6">
                                   <p><span style="font-weight: 600;">Status: </span>{{activity.status == 'Approval Recommended' ? 'In Progress' : activity.status}}</p>
                               </div>
                           </div>
                           <br>
                           <hr>
                         </div>  
                       </div>
                     </div>

                 </div>
             </div>      
         </div>
     </div>     
    <!-- END TRACKING POPUP-->
  </div>
</div>





